import LineupForEdit from "./LineupForEdit";
import { DEFAULT_PRESET_COLOR, getSavedPresetColor } from "./preset";

/**
 * The published womens lineup -- what the screenshot and video routes render.
 *
 * It renders the very same component as the editor canvas and the SaveModal
 * preview. This file used to be a separate copy of that component, and the two
 * drifted: the copy worked the jersey colour out from the last layer only, so a
 * lineup made on the red jersey was published on the white one as soon as a
 * photo had been added on top.
 *
 * All that differs here is where the inputs come from. The editor holds them in
 * its own state and passes them down; a published template only has what was
 * saved, so they are read back out of `data.editData` -- the same values, in the
 * same places, the editor restores them from when it reopens this template.
 */
const Index = (props) => {
  const editData = props.data?.data?.editData;
  const effects = editData?.effects;

  return (
    <LineupForEdit
      {...props}
      presetBgColor={getSavedPresetColor(editData?.layers) || DEFAULT_PRESET_COLOR}
      presetGkColor={effects?.gkPreset}
      manualEntries={editData?.manualEntries}
      hasCLStars={effects?.hasCLStars}
      isDfbPokal={effects?.isDfbPokal}
    />
  );
};

export default Index;
